// 方向按钮控件
let directionButton = null;
let clickLeftType = false;
let clickRightType = false;
let clickCancelType = false;
let isDragging = false;
let startX = 0;
let startY = 0;
let currentX = 0;
let currentY = 0;
let gridDataRecord = [];
let cantiSlabSectData = null;
import store from "@/store";
import { Message } from "element-ui";
import {
  clearAllHighLight,
  addEntityToDrawing,
  saveDatabaseStore,
} from "./operateApi";
import { rlCantiSlabData } from "@/rlMxModules/rlDataClass/index";
import { McGePoint3d } from "mxcad";
import { isParallel, MovePt, create_cantiSlab_ents } from "./structural";
import { getRlLayer } from "@/mixins/LiteModuleDb.js";

// 拖动相关函数
const handleDragStart = (e) => {
  isDragging = true;
  if (e.type === "mousedown") {
    startX = e.clientX - directionButton.offsetLeft;
    startY = e.clientY - directionButton.offsetTop;
  } else if (e.type === "touchstart") {
    startX = e.touches[0].clientX - directionButton.offsetLeft;
    startY = e.touches[0].clientY - directionButton.offsetTop;
  }
};

const handleDragMove = (e) => {
  if (!isDragging) return;

  if (e.type === "mousemove") {
    currentX = e.clientX - startX;
    currentY = e.clientY - startY;
  } else if (e.type === "touchmove") {
    currentX = e.touches[0].clientX - startX;
    currentY = e.touches[0].clientY - startY;
  }

  // 限制在视口范围内
  const maxX = window.innerWidth - directionButton.offsetWidth;
  const maxY = window.innerHeight - directionButton.offsetHeight;

  currentX = Math.max(0, Math.min(currentX, maxX));
  currentY = Math.max(0, Math.min(currentY, maxY));

  directionButton.style.left = currentX + "px";
  directionButton.style.top = currentY + "px";
};

const handleDragEnd = () => {
  isDragging = false;
};

// 获取按钮
export const getDirectionButton = () => {
  return directionButton;
};

// 创建分隔线
const createDivider = () => {
  const divider = document.createElement("div");
  divider.style.cssText = `
    height: 24px !important;
    width: 1px !important;
    background: rgba(0, 0, 0, 0.2) !important;
    margin: 0 4px !important;
  `;
  return divider;
};

// 创建按钮
export const createDirectionButton = (showLeft = true, showRight = true) => {
  // 检查按钮是否已存在，如果存在则先销毁
  if (directionButton) {
    destroyDirectionButton();
  }

  // 添加合并拆分按钮点击事件监听
  window.addEventListener("directionButtonClick", handleDirectionButtonClick);
  directionButton = document.createElement("div");
  directionButton.className = "rl-direction-button";

  // 设置基本样式
  directionButton.style.cssText = `
    position: fixed !important;
    top: 50px !important;
    right: 50px !important;
    z-index: 99999 !important;
    display: inline-flex !important;
    flex-direction: row !important;
    align-items: center !important;
    background: rgba(255, 255, 255, 0.9) !important;
    padding: 4px 8px !important;
    border-radius: 6px !important;
    box-shadow: 0 3px 10px rgba(0,0,0,0.15) !important;
    backdrop-filter: blur(4px) !important;
    width: fit-content !important;
    user-select: none !important;
    -webkit-user-select: none !important;
    touch-action: none !important;
    border: 1px solid rgba(0,0,0,0.1) !important;
  `;

  // 创建拖动区域
  const dragHandle = document.createElement("div");
  dragHandle.style.cssText = `
    width: 20px !important;
    height: 24px !important;
    background: rgba(0, 0, 0, 0.08) !important;
    border-radius: 4px !important;
    cursor: move !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 8px !important;
    touch-action: none !important;
  `;

  // 添加拖动图标
  const dragIcon = document.createElement("div");
  dragIcon.style.cssText = `
    width: 12px !important;
    height: 12px !important;
    background: repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.3) 0px,
      rgba(0, 0, 0, 0.3) 1px,
      transparent 1px,
      transparent 4px
    ) !important;
    border-radius: 2px !important;
  `;
  dragHandle.appendChild(dragIcon);

  // 创建按钮
  const createButton = (text, type, isVisible = true) => {
    const button = document.createElement("button");
    button.innerHTML = String(text || "");
    button.style.cssText = `
      min-width: 40px !important;
      height: 28px !important;
      border: none !important;
      border-radius: 4px !important;
      cursor: pointer !important;
      font-size: 13px !important;
      display: ${isVisible ? "block" : "none"} !important;
      transition: all 0.2s ease !important;
      font-weight: 500 !important;
      letter-spacing: 0.5px !important;
      text-align: center !important;
      line-height: 28px !important;
      padding: 0 10px !important;
      margin: 0 !important;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
      flex-shrink: 0 !important;
      touch-action: none !important;
    `;

    if (type === "primary") {
      button.style.cssText += `
        background: linear-gradient(135deg, #409EFF, #337ecc) !important;
        color: #fff !important;
      `;
    } else if (type === "secondary") {
      button.style.cssText += `
        background: linear-gradient(135deg, #67C23A, #529b2e) !important;
        color: #fff !important;
      `;
    } else {
      button.style.cssText += `
        background: linear-gradient(135deg, #909399, #6b6d71) !important;
        color: #fff !important;
      `;
    }

    // 添加悬停效果
    button.addEventListener("mouseover", () => {
      button.style.transform = "scale(1.05)";
      button.style.boxShadow = "0 2px 5px rgba(0,0,0,0.2)";
    });

    button.addEventListener("mouseout", () => {
      button.style.transform = "scale(1)";
      button.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
    });

    // 添加点击效果
    button.addEventListener("mousedown", () => {
      button.style.transform = "scale(0.95)";
    });

    button.addEventListener("mouseup", () => {
      button.style.transform = "scale(1)";
    });

    return button;
  };

  // 创建三个按钮
  const leftButton = createButton("左", "primary", showLeft);
  const rightButton = createButton("右", "primary", showRight);
  const cancelButton = createButton("取消", "info");

  // 添加点击事件
  leftButton.addEventListener("click", (e) => {
    e.stopPropagation(); // 阻止冒泡
    clickLeftType = true;
    // 触发自定义事件，通知父组件
    window.dispatchEvent(
      new CustomEvent("directionButtonClick", {
        detail: { type: "left" },
      })
    );
  });

  rightButton.addEventListener("click", (e) => {
    e.stopPropagation(); // 阻止冒泡
    clickRightType = true;
    // 触发自定义事件，通知父组件
    window.dispatchEvent(
      new CustomEvent("directionButtonClick", {
        detail: { type: "right" },
      })
    );
  });

  cancelButton.addEventListener("click", (e) => {
    e.stopPropagation(); // 阻止冒泡
    clickCancelType = true;
    // 触发自定义事件，通知父组件
    window.dispatchEvent(
      new CustomEvent("directionButtonClick", { detail: { type: "cancel" } })
    );
  });

  // 添加拖动事件监听器到拖动区域
  dragHandle.addEventListener("mousedown", handleDragStart);
  dragHandle.addEventListener("touchstart", handleDragStart, {
    passive: false,
  });
  document.addEventListener("mousemove", handleDragMove);
  document.addEventListener("mouseup", handleDragEnd);
  document.addEventListener("touchmove", handleDragMove, { passive: false });
  document.addEventListener("touchend", handleDragEnd);

  // 添加拖动区域和按钮到容器
  directionButton.appendChild(dragHandle);
  directionButton.appendChild(leftButton);
  directionButton.appendChild(createDivider()); // 添加左右按钮之间的分隔线
  directionButton.appendChild(rightButton);
  directionButton.appendChild(createDivider()); // 添加右和取消按钮之间的分隔线
  directionButton.appendChild(cancelButton);

  // 添加到body
  if (document.body) {
    document.body.appendChild(directionButton);
  }

  return directionButton;
};

// 获取点击状态
export const getClickLeftType = () => {
  return clickLeftType;
};

export const getClickRightType = () => {
  return clickRightType;
};

export const getClickCancelType = () => {
  return clickCancelType;
};

// 设置点击状态
export const setClickLeftType = (type) => {
  clickLeftType = type;
};

export const setClickRightType = (type) => {
  clickRightType = type;
};

export const setClickCancelType = (type) => {
  clickCancelType = type;
};

// 销毁按钮
export const destroyDirectionButton = (clearGridDataRecord = true) => {
  if (directionButton) {
    // 移除事件监听器
    document.removeEventListener("mousemove", handleDragMove);
    document.removeEventListener("mouseup", handleDragEnd);
    document.removeEventListener("touchmove", handleDragMove);
    document.removeEventListener("touchend", handleDragEnd);

    directionButton.remove();
    directionButton = null;
  }
  for (const item of gridDataRecord) {
    if (!item.isSame) {
      item.polylineObj.erase();
    }
  }
  clearAllHighLight();
  gridDataRecord = [];
  cantiSlabSectData = null;

  // if (clearGridDataRecord) {

  // }

  clickLeftType = false;
  clickRightType = false;
  clickCancelType = false;
  window.removeEventListener(
    "directionButtonClick",
    handleDirectionButtonClick
  );
};

// 修改按钮位置
export const setDirectionButtonPosition = (x, y) => {
  if (!directionButton) {
    return;
  }
  // 坐标转换
  const selectObjPoint = rlAppObj._rlMx.MxFun.cadCoord2Doc(x, y);
  // 将文档坐标转换为屏幕坐标
  const pxPoint = rlAppObj._rlMx.MxFun.docCoord2Screen(
    selectObjPoint.x,
    selectObjPoint.y
  );
  directionButton.style.left = pxPoint.x + "px";
  directionButton.style.top = pxPoint.y + "px";
};

// 处理布置悬挑板按钮点击事件
const handleDirectionButtonClick = async (e) => {
  const { type } = e.detail;
  let row = {
    tableRow: cantiSlabSectData,
  };
  if (type === "left") {
    // 执行左按钮的逻辑
    await createCantiSlab("left");
    destroyDirectionButton(false);
  } else if (type === "right") {
    // 执行右按钮的逻辑
    await createCantiSlab("right");
    destroyDirectionButton(false);
  } else if (type === "cancel") {
    // 执行取消按钮的逻辑
    destroyDirectionButton();
  }
  await create_cantiSlab_ents(store.state.globalData.rl_stdFlr_id, row);
};

//计算线段的左或右的方向
export const calculateVecType = (startPoint, endPoint) => {
  // 根据起点和终点计算向量
  const vectorX = endPoint.x - startPoint.x;
  const vectorY = endPoint.y - startPoint.y;

  // 计算向量长度
  const length = Math.sqrt(vectorX * vectorX + vectorY * vectorY);

  // 标准化原始向量
  const normalizedX = length > 0 ? vectorX / length : 0;
  const normalizedY = length > 0 ? vectorY / length : 0;

  // 根据逆时针规则计算左右向量
  // 左方向：逆时针旋转90度 (-y, x)
  const leftVectorX = -normalizedY;
  const leftVectorY = normalizedX;

  // 右方向：顺时针旋转90度 (y, -x)
  const rightVectorX = normalizedY;
  const rightVectorY = -normalizedX;

  // 返回三个标准化方向向量：原方向、左方向和右方向
  return {
    // 原始方向向量（已标准化）
    origin: new THREE.Vector3(normalizedX, normalizedY, 0),
    // 左侧向量（逆时针旋转90度，已标准化）
    left: new THREE.Vector3(leftVectorX, leftVectorY, 0),
    // 右侧向量（顺时针旋转90度，已标准化）
    right: new THREE.Vector3(rightVectorX, rightVectorY, 0),
  };
};

//计算楼板的点集
export const calculateSlabPoints = (startPoint, endPoint, vec) => {
  const points = [];
  if (!startPoint || !endPoint || !cantiSlabSectData) return [];
  points.push(startPoint);
  points.push(MovePt(startPoint, vec, cantiSlabSectData.Length));
  points.push(MovePt(endPoint, vec, cantiSlabSectData.Length));
  points.push(endPoint);
  return points;
};

//创建悬挑板
export const createCantiSlab = async (vecType) => {
  if (!cantiSlabSectData) return;
  const rlLayer = await getRlLayer();
  let cantiSlabColor = rlLayer.filter((item) => item.Type == "rlCantiSlab");
  if (cantiSlabColor && cantiSlabColor.length > 0)
    cantiSlabColor = cantiSlabColor[0].Color;
  // 拿到对应标准层
  var rlBuilding = store.state.cadModules.rlBuilding;
  var currFlrHeight = Number(rlBuilding.Height) ?? 3000; // 当前楼层的高度
  var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
  for (const item of gridDataRecord) {
    let startPoint = new McGePoint3d(...item.gridData.m_stJoint.m_pt);
    let endPoint = new McGePoint3d(...item.gridData.m_edJoint.m_pt);
    if (item.isSame) {
      startPoint = new McGePoint3d(...item.gridData.m_stJoint.m_pt);
      endPoint = new McGePoint3d(...item.gridData.m_edJoint.m_pt);
    } else {
      item.polylineObj.erase();
      startPoint = item.startPoint;
      endPoint = item.endPoint;
    }

    //不与X轴平行,互换起点和终点
    if (startPoint.x != endPoint.x) {
      if (startPoint.y == endPoint.y && startPoint.x < endPoint.x) {
        [startPoint, endPoint] = [endPoint, startPoint];
      } else if (startPoint.y != endPoint.y)
        [startPoint, endPoint] = [endPoint, startPoint];
    } else if (startPoint.x == endPoint.x) {
      if (startPoint.y > endPoint.y) {
        [startPoint, endPoint] = [endPoint, startPoint];
      }
    }
    const vec = calculateVecType(startPoint, endPoint);
    let cantiSlabVec = null;
    if (vecType == "left") {
      cantiSlabVec = vec.left;
      // 左
    } else if (vecType == "right") {
      // 右
      cantiSlabVec = vec.right;
    } else continue;
    const points = calculateSlabPoints(startPoint, endPoint, cantiSlabVec);
    const createCantiSlab = new rlCantiSlabData();
    createCantiSlab.initData({
      m_sectParamData: cantiSlabSectData,
      points,
      Color: cantiSlabColor,
      m_gridData: item.gridData,
      Thickness: cantiSlabSectData.Thick,
      LevelB: currFlrLevelB,
      Height: currFlrHeight,
    });
    createCantiSlab.draw();
    await addEntityToDrawing(createCantiSlab, false);
  }
  // 更新显示
  rlAppObj.rlMxDrawObject.updateDisplay();
  // 将操作步骤下的所有数据更新到数据库中
  await saveDatabaseStore();
};

export const setGridDataRecord = (data) => {
  gridDataRecord = data;
};

export const getGridDataRecord = () => {
  return gridDataRecord;
};
//获取按钮位置是否被创建
export const getDirectionButtonIsCreate = () => {
  return directionButton ? true : false;
};

export const setCantiSlabSectData = (data) => {
  cantiSlabSectData = data;
};
